import React from 'react';
import styled from "styled-components";

const Rules = () => {
    return (
        <Wrapper>
            <Content>
                <h2> PEŁNY REGULAMIN KONKURSU</h2>
                <p>Międzynarodowy konkurs na plakat dla studentów i absolwentów ostatnich 5 lat po ukończeniu studiów
                    (wszystkich stopni) pod tytułem 550 urodziny Mikołaja Kopernika.
                    Konkurs odbywa się w ramach Światowego Kongresu Kopernikańskiego, z okazji ustanowienia uchwałą
                    Senatu
                    RP roku 2023 Rokiem Mikołaja Kopernika.
                    Kongres organizują wspólnie: Uniwersytet Mikołaja Kopernika w Toruniu, Uniwersytet Jagielloński w
                    Krakowie, Uniwersytet Warmińsko-Mazurski w Olsztynie oraz Polska Akademia Nauk.
                </p>

                <h2> ORGANIZATOR:</h2>
                <p> Uniwersytet Warmińsko-Mazurski w Olsztynie, Wydział Sztuki oraz Wydział Humanistyczny </p>

                <h2>PARTNERZY:</h2>
                <p>Uniwersytet Mikołaja Kopernika w Toruniu </p>
                <p>Galeria Wozownia Sztuk we Fromborku </p>

                <h2>CEL KONKURSU:</h2>
                <p>Wyłonienie najciekawszych plakatów, kreacji graficznych na temat przewodni konkursu – 550.
                    urodziny Mikołaja Kopernika. </p>

                <h2>UCZESTNICY KONKURSU:</h2>
                <p>Konkurs skierowany jest do absolwentów z ostatnich 5 lat i studentów uczelni wyższych o
                    profilu artystycznym i projektowym (dyplom uzyskany nie wcześniej niż w 2018 roku).
                    Udział w konkursie jest dobrowolny i bezpłatny. </p>

                <p>Prace konkursowe muszą być realizowane i zgłaszane do konkursu indywidualnie.
                    Konkurs ma charakter otwarty, dwuetapowy. </p>

                <h2> WARUNKI UCZESTNICTWA:</h2>
                <p>1. Do konkursu mogą przystąpić uczestnicy, którzy zapoznali się z niniejszym Regulaminem i akceptują
                    jego postanowienia. </p>
                <p>2. Warunkiem udziału w konkursie jest złożenie: </p>
                <p> — pracy konkursowej zgodnie z podanymi w regulaminie wytycznymi; </p>
                <p>— wypełnionego formularza zgłoszenia wraz z: danymi adresowymi, nazwą uczelni, kraju, w przypadku
                    absolwentów roku jej ukończenia; </p>
                <p>— podpisanego Oświadczenia (załącznik do regulaminu). </p>
                <p>3. Wraz z przesłaniem pracy Autor: </p>
                <p>— zgodnie z wymaganiami określonymi w Regulaminie udziela Organizatorowi Konkursu niewyłącznej
                    licencji (wraz z prawem do udzielania dalszej licencji) bez ograniczeń terytorialnych i przez czas
                    nieokreślony, na korzystanie z Pracy do celów związanych z organizacją Konkursu i jego promocją oraz
                    do celów realizacji wystaw pokonkursowych, jak również do promocji i informacji o działalności
                    statutowej Organizatora– na polach eksploatacji obejmujących: </p>
                <p>a. w zakresie utrwalania i zwielokrotniania, wytwarzania dowolną techniką nieograniczonej ilości
                    egzemplarzy, w tym techniką drukarską, reprograficzną, audiowizualną, zapisu magnetycznego, techniką
                    cyfrową, </p>
                <p>b. w zakresie rozpowszechniania w inny sposób – publiczne wystawienie, wyświetlenie, odtworzenie oraz
                    nadawanie i reemitowanie, w tym w sieci Internet, wprowadzenie do pamięci komputera, przesyłanie za
                    pomocą sieci multimedialnej, w tym w sieci Internet oraz inne publiczne udostępnianie w taki sposób,
                    aby każdy mógł mieć do nich dostęp w miejscu i czasie przez siebie wybranym </p>
                <p>— oświadcza, że praca nie narusza praw osób trzecich, w szczególności nie narusza ich majątkowych i
                    osobistych praw autorskich </p>
                <p> — wyraża zgodę na przetwarzanie swoich danych osobowych zawartych w ofercie konkursowej. </p>
                <p>4. Uczestnicy zgłaszają swoje prace jako pliki jpg opisane w nazwie imieniem, nazwiskiem i numerem
                    pracy, np. adam_kowalsky_1.jpg. Natomiast zabrania się podawania imienia i nazwiska w jakimkolwiek
                    miejscu na pracy. </p>
                <p> 5. Uczestnik konkursu może zgłosić maksymalnie 3 plakaty (każdy musi być opatrzony odrębną kartą
                    zgłoszenia). </p>
                <p>6. Prace nagrodzone stają się własnością Organizatora konkursu, który może je w dowolny sposób
                    wykorzystywać. Autorzy nagrodzonych plakatów przenoszą na Organizatora autorskie prawa majątkowe do
                    prac oraz udzielają zgody na wykorzystanie ich na wszystkich polach eksploatacji. </p>

                <h2>SKŁADANIE PRAC KONKURSOWYCH:</h2>
                <p>1. Wersję poglądową każdej zgłaszanej pracy konkursowej wraz z akceptacją regulaminu i oświadczenia
                    należy
                    przesłać przez formularz znajdujący się na stronie konkursu: http://rokkopernika.uwm.edu.pl/konkurs/
                    w postaci pliku cyfrowego: format 10 × 7 cm (wyłącznie orientacja pionowa), 300 dpi, RGB, jpg
                    (maksymalnie 5 MB) do dnia 30 kwietnia 2023 r. </p>
                <p> 2. Każdy plik jpg pracy należy nazwać swoim imieniem i nazwiskiem i numerem pracy, np.
                    adam_kowalsky_1.jpg. Natomiast zabrania się podawania imienia i nazwiska, w jakimkolwiek miejscu na
                    pracy. </p>
                <p>3. Ostateczny termin nadsyłania prac konkursowych (wglądówek): 30 kwietnia 2023 r.</p>
                <p>4. Finaliści zostaną poinformowani o wynikach drogą mailową i będą zobowiązani do przesłania poprzez
                    formularz na stronie konkursowej plik plakatu do druku w formacie B1, 100 x 70 cm, 200 dpi, jpg,
                    CMYK, (maksymalnie 30 MB): w terminie do 30 maja 2023 r. Dodatkowe szczegóły zostaną podane
                    finalistom w późniejszym terminie, w odrębnej korespondencji mailowej.</p>
                <p>4. Ostateczny termin
                    nadsyłania prac
                    finałowych Hi-Res do
                    druku: 30 maja 2023 r.</p>
                <p>5. Prace konkursowe
                    niespełniające wymagań,
                    o których mowa w
                    Regulaminie konkursu lub
                    nadesłane po upływie
                    terminu nie będą
                    podlegały ocenie Jury.</p>
                <p>6. Prace zawierające
                    treści powszechnie
                    uznawane za obelżywe i
                    wulgarne nie będą
                    dopuszczone do konkursu.</p>

                <h2>TERMINY:</h2>

                <p>Ogłoszenie konkursu: 18 luty 2023</p>
                <p>Otwarcie rejestracji prac: 15 marca 2023</p>
                <p>Data przesłania projektów: 30 kwietnia 2023 godz. 23.59</p>
                <p>Lista osób zakwalifikowanych: 15 maja 2023</p>
                <p> Data przesłania plików Hi-Res: 30 maja 2023</p>
                <p>Ogłoszenie finalistów i zwycięzców: czerwiec 2023</p>
                <p> Wystawy pokonkursowe: czerwiec 2023 — grudzień 2023</p>

                <h2>NAGRODY:</h2>
                <p>Spośród nadesłanych zgłoszeń międzynarodowe Jury wyłoni laureatów:</p>

                <p> Grand Prix - 3000 PLN,</p>
                <p> 1 Nagroda - 2000 PLN,</p>
                <p>2 Nagroda - 1500 PLN,</p>
                <p>3 Nagroda - 1000 PLN,</p>
                <p>Wyróżnienie - 500 PLN</p>

                <p> oraz maksymalnie 100 finalistów, których plakaty zostaną zaprezentowane na wystawach pokonkursowych
                    w Centrum Ekspozycyjnym Stara Kotłownia w Olsztynie oraz we Fromborku i Toruniu. Spośród plakatów
                    zakwalifikowanych do finału 20 najlepszych zostanie wystawionych w przestrzeni miejskiej
                    Olsztyna, Fromborka oraz na Gali Finałowej w Olsztynie podczas Konferencji Kopernikańskiej. </p>
                <p>Finaliści konkursu otrzymają stosowne certyfikaty. Organizator zastrzega możliwość innego podziału
                    nagród, zmiany terminów, miejsc i formy ekspozycji prac. Ponadto uzależnia te czynniki także od
                    sytuacji epidemicznej (lokalnej i globalnej).</p>
                <h2>JURY:</h2>
                <p>1. Prace konkursowe będą oceniane przez dwuetapowe międzynarodowe Jury Konkursowe powołane przez
                    Organizatora w składzie:</p>
                <h3>Jury preselekcyjne:</h3>
                <p> 1. dr Jarek Bujny, Uniwersytet Warmińsko-Mazurski, Polska</p>
                <p>2. prof. Violetta Kulikowska-Parkasiewicz, Uniwersytet Warmińsko-Mazurski, Polska</p>
                <p>3. prof. Barnabas Wetton, Designskolen Kolding, Dania</p>
                <p>4. prof. Byoung Il Sun, Namseoul University. Korea</p>
                <p>5. Susana Machicao Pacheco, Dyrektor Disenadores Graficos Bolivia, Boliwia</p>

                <h3>Jury finałowe</h3>
                <p>1. dr Jarek Bujny, Uniwersytet Warmińsko-Mazurski, Polska</p>
                <p>2. dr hab. Agnieszka Ziemiszewska, Polsko-Japońska Akademia Technik Komputerowych w Warszawie,
                    Polska</p>
                <p>3. dr hab. Nikodem Pręgowski, Uniwersytet Mikołaja Kopernika w Toruniu, Polska</p>
                <p>4. Rikke Hansen, Dania</p>
                <p>5. prof. Joost Bottema, Merz Akademie, Niemcy / Holandia</p>

                <p>2. Zadaniem Jury jest ocena prac konkursowych oraz wyłonienie laureatów i finalistów.</p>
                <p>3. Wyniki konkursu zostaną opublikowane na stronie internetowej Konkursu:
                    http://rokkopernika.uwm.edu.pl/konkurs/</p>
                <p>4. Decyzje Jury są ostateczne i nie przysługuje od nich odwołanie.</p>

                <h2>INNE POSTANOWIENIA:</h2>
                <p>Przystąpienie do konkursu oznacza, że w przypadku zakwalifikowania wybranych projektów, ich Autorzy
                    przenoszą na Organizatora — na
                    zasadzie wyłączności i bez ograniczeń terytorialnych oraz czasowych — w całości autorskie prawa
                    majątkowe do wykonanych prac na polach eksploatacji wskazanych w art. 50 ustawy z dnia 4 lutego 1994
                    r. o prawie autorskim i
                    prawach pokrewnych (Dz. U. 2019 r. poz. 1231 t.j. ze zm.). Odmowa ww. skutkuje wycofaniem pracy z
                    konkursu. Organizator ma prawo dokonywania w projekcie zmian koniecznych ze
                    względu na pole eksploatacji, na którym projekt będzie wykorzystany; decyduje czy, kiedy i w jakim
                    zakresie będzie rozpowszechniany projekt. Uczestnicy
                    konkursu wyrażają zgodę na przetwarzanie ich danych osobowych dla potrzeb niezbędnych do realizacji
                    konkursu zgodnie z treścią
                    Oświadczenia, stanowiącego załącznik do niniejszego regulaminu. Przystąpienie do konkursu oznacza
                    wyrażenie zgody bez zastrzeżeń na warunki niniejszego regulaminu. Członkowie Jury nie mogą
                    brać udziału w konkursie. Organizator konkursu nie ponosi odpowiedzialności za ewentualne
                    przedłużenie, skrócenie, zmiany lub odwołanie konkursu z przyczyn od niego niezależnych.</p>
                <h2>ODPOWIEDZIALNOŚĆ
                    ORGANIZATORA:</h2>
                <p>1. Organizator nie odpowiada za jakąkolwiek szkodę majątkową lub niemajątkową, w tym uszczerbek,
                    stratę, naruszenie integralności cielesnej lub straty moralne, poniesione przez Uczestnika w wyniku
                    jego udziału w Konkursie lub w wyniku przyznania lub nieprzyznania mu nagrody.</p>
                <p>2. Uczestnik ponosi pełną i wyłączną odpowiedzialność w przypadku, kiedy jego zgłoszenie udziału w
                    Konkursie będzie naruszało prawa osób trzecich, postanowienia Regulaminu lub obowiązujące przepisy
                    prawa.</p>
                <p>3. Organizator nie ponosi odpowiedzialności za mające wpływ na prawidłowość zgłoszeń: błędy,
                    pominięcie, kradzież, zniszczenie, zamianę, nieupoważniony dostęp do zgłoszeń, utratę zgłoszeń
                    lub ich opóźnienie w doręczeniu Organizatorowi spowodowane przez działanie czynników
                    pozostających poza wpływem Organizatora.</p>
                <h2>POSTANOWIENIA KOŃCOWE:</h2>
                <p>Zwycięzcy będą informowani mailowo. We wszelkich sprawach nieuregulowanych niniejszym Regulaminem
                    zastosowanie mają odpowiednie przepisy Kodeksu cywilnego i Rozporządzenia Parlamentu
                    Europejskiego i Rady (UE) 2016/679. Wszelkie spory dotyczące
                    Konkursu, wynikłe pomiędzy Organizatorem a Uczestnikami będą rozstrzygane przez sąd powszechny
                    właściwy dla siedziby Organizatora. Wszelkich informacji udziela sekretariat
                    konkursu z siedzibą na Wydziale Sztuki, Uniwersytetu Warmińsko-Mazurskiego, pod adresem;
                    550poster@uwm.edu.pl</p>

<br/>
                <a href={'https://firebasestorage.googleapis.com/v0/b/rkkp-uwm.appspot.com/o/RULES-REGULAMIN%20550%20PL%20ENG.pdf?alt=media&token=d7dc52ed-d7d1-4d04-ab53-370242c1b6a1'} download>pobierz regulamin</a>



            </Content>
        </Wrapper>
    )
}

export default Rules


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12% 10% 0 10%;
  position: relative;

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
  }

  h3 {
    font-family: Lato;
    color: white;
    background-color: #E44432;
    font-size: 20px;
    font-weight: 600;
    padding: 20px;
    border-radius: 50px;
  }

  h2 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 0px 10px;
    border-radius: 50px;
  }

  p {
    margin: 0;
    font-family: Lato;
    margin-bottom: 12px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 1.5;
  }
`


const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;

  @media (max-width: 768px) {
    width: 100vw;
    box-sizing: border-box;
    padding: 20px;
  }
`

